// extracted by mini-css-extract-plugin
export default {"title":"Products_title__ywPrT","description":"Products_description__iwuLN"};